import { EventEmitter, Injectable, Input, Output } from '@angular/core';
import * as Track from '@project/shared/utils/tracking/js/tracking';
import * as i0 from "@angular/core";
var ButtonMarketoFunction = /** @class */ (function () {
    function ButtonMarketoFunction() {
        this.buttonClick = new EventEmitter();
        this.classes = {
            buttonClose: 'js-m-marketo-lightbox__close',
            stateLightboxVisible: 'state-m-marketo-lightbox--visible',
            lightboxDialog: 'm-marketo-lightbox__dialog',
            lightboxLoading: 'm-marketo-lightbox__dialog-loading',
            lightbox: 'm-marketo-lightbox',
            stateContentHide: 'm-marketo-lightbox--block-hidden',
            blockedMsg: 'js-m-marketo-lightbox-blocked-msg',
            formProductName: 'js-m-stage-product__headline',
            lightboxComponent: 'js-m-marketo-lightbox-component',
            contactImage: 'js-m-marketo-form__contact-image',
            stateHasImage: 'm-marketo-form__has-contact-image',
            stateAdditionalFieldsVisible: 'm-marketo-form__show-additional-fields',
            rowHide: 'mktoFormRowHide',
            autoSuggestDropdown: 'js-m-marketo-form_product-autosuggest',
            dropdownItem: 'js-m-marketo-form_dropdown-item',
        };
        this._marketoFormInitialized = false;
        this._marketoFormInitializationTimer = null;
    }
    ButtonMarketoFunction.prototype.onDownloadBtnClicked = function (e, lightboxComponent) {
        var flowId = $(e.target).data('mktoflow-id');
        var closeButtonDisabled = $(e.target).data('mktoflow-close-disabled');
        var videoId = $(e.target).data('video-id');
        var campaignId = $(e.target).data('mktocampaign-main-id');
        var href = $(e.target).attr('href');
        var themeModeAttribute = $(e.target).data('mkto-themeattribute');
        this.mktolightboxComponent = lightboxComponent;
        e.stopPropagation();
        e.preventDefault();
        if (flowId != undefined) {
            if (flowId.length > 0) {
                if (!Track.isKnownMarketoLead()) {
                    this.getMktoLightboxView(flowId, href, closeButtonDisabled, themeModeAttribute, campaignId, videoId);
                    return false;
                }
                else {
                    this.getMktoLightboxData(flowId, href, closeButtonDisabled, themeModeAttribute, campaignId, videoId);
                }
            }
            else {
                console.log('lightbox: flow-id is empty');
            }
        }
        else {
            console.log('lightbox: flow-id is undefined');
        }
        if (this.emitEvent === true) {
            this.buttonClick.emit();
        }
    };
    ButtonMarketoFunction.prototype.getMktoLightboxView = function (flowId, originalHref, closeButtonDisabled, themeModeAttribute, campaignId, videoId) {
        var _this_1 = this;
        if (themeModeAttribute === void 0) { themeModeAttribute = ''; }
        if (campaignId === void 0) { campaignId = ''; }
        if (videoId === void 0) { videoId = ''; }
        // partial view is called, show black-transparent overlay and loading indicator
        this.showLightbox();
        this.showIndicator();
        if (closeButtonDisabled == undefined) {
            closeButtonDisabled = false;
        }
        if (originalHref == undefined) {
            originalHref = '';
        }
        if (themeModeAttribute == undefined) {
            themeModeAttribute = '';
        }
        var formProductName = $('html').find("." + this.classes.formProductName);
        if (formProductName.length > 0) {
            this.productNameValue = $(formProductName[0]).text();
        }
        var endpoint = '/partial-updates/marketo/lightboxpartial';
        $.ajax({
            type: 'get',
            url: endpoint,
            dataType: 'html',
            data: {
                flowId: flowId,
                originLink: originalHref,
                closeButtonDisabled: closeButtonDisabled,
                themeModeAttribute: themeModeAttribute,
                campaignId: campaignId,
                productName: this.productNameValue,
            },
            success: function (response) {
                if (response.length > 2) {
                    var $dialog = _this_1.mktolightboxComponent.find("div." + _this_1.classes.lightboxDialog);
                    $dialog.empty();
                    $dialog.append(response);
                    _this_1.rebindEvents();
                    _this_1.loadForm(originalHref, videoId);
                }
                else {
                    console.log('lightbox: get partial-view failed');
                    _this_1.closeLightbox();
                    _this_1.doSubmitAction(false, originalHref, videoId);
                }
            },
            complete: function () { },
            error: function (xhr, status, error) {
                console.log("lightbox: get partial-view error, endpoint: " + endpoint + ", " + xhr.status + ", " + xhr.statusText + ", " + error);
                _this_1.doSubmitAction(false, originalHref, videoId);
            },
        });
    };
    ButtonMarketoFunction.prototype.getMktoLightboxData = function (flowId, originalHref, closeButtonDisabled, themeModeAttribute, campaignId, videoId) {
        var _this_1 = this;
        if (themeModeAttribute === void 0) { themeModeAttribute = ''; }
        if (campaignId === void 0) { campaignId = ''; }
        if (videoId === void 0) { videoId = ''; }
        var $this = this;
        if (closeButtonDisabled == undefined) {
            closeButtonDisabled = false;
        }
        if (originalHref == undefined) {
            originalHref = '';
        }
        if (themeModeAttribute == undefined) {
            themeModeAttribute = '';
        }
        var endpoint = '/partial-updates/marketo/lightboxpartialformdata';
        $.ajax({
            type: 'get',
            url: endpoint,
            dataType: 'html',
            data: {
                flowId: flowId,
                originLink: originalHref,
                isDisplayForm: true,
                campaignId: campaignId,
            },
            success: function (response) {
                if (response.length > 2) {
                    var $dialog = _this_1.mktolightboxComponent.find("div." + _this_1.classes.lightboxDialog);
                    $dialog.empty();
                    $dialog.append(response);
                    $this.rebindEvents();
                    $this.loadForm('', '');
                    var $lightboxContainer = _this_1.mktolightboxComponent.find("div[data-id=\"lightboxContainer\"]");
                    var IsHiddenFormSubmitrequired = $lightboxContainer.data('hidden-form-submit-required');
                    var HiddenFormSubmitId = $lightboxContainer.data('lightbox-form-id');
                    if (IsHiddenFormSubmitrequired == true) {
                        var MktoForms2 = window['MktoForms2'];
                        MktoForms2.whenReady(function (form) {
                            console.log(form.getId());
                            if (HiddenFormSubmitId !== undefined && Number(HiddenFormSubmitId) == form.getId()) {
                                form.submit();
                                $this.hiddenFormSubmit(form);
                                return false;
                            }
                        });
                    }
                    return false;
                }
                else {
                    console.log('lightbox: get partial-view failed');
                    _this_1.closeLightbox();
                    _this_1.doSubmitAction(false, '', '');
                }
            },
            complete: function () { },
            error: function (xhr, status, error) {
                console.log("lightbox: get partial-data error, endpoint: " + endpoint + ", " + xhr.status + ", " + xhr.statusText + ", " + error);
            },
        });
    };
    ButtonMarketoFunction.prototype.loadForm = function (originalHref, videoId) {
        var _this_1 = this;
        if (videoId === void 0) { videoId = ''; }
        var MktoForms2 = window['MktoForms2'];
        var _this = this;
        if (typeof MktoForms2 != 'object' && this._marketoFormInitializationTimer == null) {
            // Watch for te Marketo script being loaded.
            //	Mechanism based on https://nation.marketo.com/t5/product-blogs/accurately-background-loading-the-mktoforms2-global-object/ba-p/309609
            document.addEventListener('load', function () { return _this_1.loadForm(originalHref); }, true);
            // Display failure text after a delay (give the script some time to load)
            this._marketoFormInitializationTimer = window.setTimeout(function () {
                _this_1._marketoFormInitializationTimer = null;
                // Marketo is broken, user has disabled tracking or scripts are blocked
                console.debug('Lightbox: form is blocked');
                _this.hideIndicator();
                _this.displayFormBox();
                _this.mktolightboxComponent.find("." + _this_1.classes.blockedMsg).removeClass(_this_1.classes.stateContentHide);
            }, 3000);
        }
        else if (typeof MktoForms2 == 'object' && !this._marketoFormInitialized) {
            document.removeEventListener('load', function () { return _this_1.loadForm(originalHref); }, true);
            this._marketoFormInitialized = true;
            if (this._marketoFormInitializationTimer) {
                clearTimeout(this._marketoFormInitializationTimer);
            }
            var $formContainer = this.mktolightboxComponent.find("div[data-id=\"formContainer\"]");
            var showMessage_1 = $formContainer.parent('div[data-id="lightboxContainer"]').data('show-message');
            var formHref = $formContainer.data('form-href');
            var envId = $formContainer.data('environment-id');
            var formId = $formContainer.data('form-id');
            var $formNode_1 = $formContainer.find('form');
            MktoForms2.loadForm(formHref, envId, formId, function (form) {
                try {
                    // partial view is called successfully, hide indicator
                    _this.hideIndicator();
                    _this.displayFormBox();
                    form.onSuccess(function (values, followUpUrl) {
                        Track.setKnownMarketoLead(true);
                        _this.doSubmitAction(showMessage_1, originalHref, videoId);
                        var IsSendDataToGtm = $formNode_1.data('sc-send-data-to-gtm');
                        if (IsSendDataToGtm) {
                            var typeOfForm = $formNode_1.data('show-message');
                            var trackdata = {
                                event: 'form_submit',
                                form_id: $($formNode_1).attr('id'),
                                form_name: typeOfForm,
                                form_destination: '',
                                form_submit_text: '',
                            };
                            Track.gtmTrack(trackdata);
                        }
                        return false;
                    });
                    form.onSubmit(function () {
                        _this.formatPhoneNumber(form);
                    });
                    if (Track.isKnownMarketoLead()) {
                        form.vals({ formVersion: 'Known' });
                    }
                }
                catch (error) {
                    _this.mktolightboxComponent
                        .find("." + this.classes.blockedMsg)
                        .removeClass(this.classes.stateContentHide);
                }
            });
            _this.initializeMarketoOnScriptLoad();
        }
    };
    ButtonMarketoFunction.prototype.rebindEvents = function () {
        var $this = this;
        this.mktolightboxComponent.find("." + this.classes.buttonClose).on('click', function () {
            $this.closeLightbox();
        });
    };
    ButtonMarketoFunction.prototype.removeCloseEvents = function () {
        var $this = this;
        this.mktolightboxComponent.find("." + this.classes.buttonClose).off('click', function () {
            $this.closeLightbox();
        });
    };
    ButtonMarketoFunction.prototype.showLightbox = function () {
        $('html')
            .find("." + this.classes.lightbox)
            .addClass(this.classes.stateLightboxVisible);
        $('html').addClass('no-scrolling--without-scrollbar');
    };
    ButtonMarketoFunction.prototype.closeLightbox = function () {
        this.mktolightboxComponent.removeClass(this.classes.stateLightboxVisible);
        this.mktolightboxComponent.find("." + this.classes.lightboxDialog).empty();
        $('html').removeClass('no-scrolling--without-scrollbar');
        this._marketoFormInitialized = false;
        this._marketoFormInitializationTimer == null;
    };
    ButtonMarketoFunction.prototype.displayConfirmationBox = function () {
        var $confirmContainer = this.mktolightboxComponent.find("div[data-id=\"confirmationContainer\"]");
        $confirmContainer.removeClass(this.classes.stateContentHide);
    };
    ButtonMarketoFunction.prototype.displayFormBox = function () {
        var $formContainer = this.mktolightboxComponent.find("div[data-id=\"formContainer\"]");
        $formContainer.removeClass(this.classes.stateContentHide);
    };
    ButtonMarketoFunction.prototype.hideFormBox = function () {
        var $formContainer = this.mktolightboxComponent.find("div[data-id=\"formContainer\"]");
        $formContainer.addClass(this.classes.stateContentHide);
    };
    ButtonMarketoFunction.prototype.hideIndicator = function () {
        var $dialog = this.mktolightboxComponent.find("." + this.classes.lightboxDialog);
        $dialog.removeClass(this.classes.stateContentHide);
        var $indicator = this.mktolightboxComponent.find("." + this.classes.lightboxLoading);
        $indicator.addClass(this.classes.stateContentHide);
    };
    ButtonMarketoFunction.prototype.showIndicator = function () {
        var $dialog = this.mktolightboxComponent.find("." + this.classes.lightboxDialog);
        $dialog.addClass(this.classes.stateContentHide);
        var $indicator = this.mktolightboxComponent.find("." + this.classes.lightboxLoading);
        $indicator.removeClass(this.classes.stateContentHide);
    };
    ButtonMarketoFunction.prototype.doSubmitAction = function (showConfirmationMsg, originalHref, videoId) {
        if (videoId === void 0) { videoId = ''; }
        // confirmation message
        if (showConfirmationMsg) {
            this.hideFormBox();
            this.displayConfirmationBox();
            // go to original link
        }
        else {
            this.closeLightbox();
            if (videoId.length > 0) {
                //play
                $('[data-video-id="' + videoId + '"] .mi-big-play-cover').trigger('click');
                $('[data-video-id="' + videoId + '"] .js-a-video__locked').remove();
            }
            else {
                if (originalHref != undefined && originalHref.length > 0) {
                    window.location.href = originalHref;
                }
            }
        }
        //unlock
        $('.a-video--locked').removeClass('a-video--locked');
        $('.m-download-item--locked').removeClass('m-download-item--locked');
        $('.m-download-table__item--locked').removeClass('m-download-table__item--locked');
        $('.m-hero-article-stage--locked').removeClass('m-hero-article-stage--locked');
        $('.m-scrollable-teaser-item--locked').removeClass('m-scrollable-teaser-item--locked');
        $('.m-talk--locked').removeClass('m-talk--locked');
        $('.m-teaser-large--locked').removeClass('m-teaser-large--locked');
        $('.o-teaser-content-area__item').each(function (i, e) {
            var $teaser = $(e).children();
            var classList = $teaser.attr('class');
            var className = classList.split(' ');
            $teaser.removeClass(className[0] + '--locked');
        });
    };
    ButtonMarketoFunction.prototype.initializeMarketoOnScriptLoad = function () {
        var $this = this;
        var timerRef = setTimeout(function () {
            var MktoForms2 = window['MktoForms2'];
            if (typeof MktoForms2 != 'undefined') {
                clearTimeout(timerRef);
                MktoForms2.whenReady(function (form) {
                    var $component = $(form.getFormElem()[0]).closest('div[data-t-name]');
                    $this.initMessageBox($component);
                    // translate form
                    $this.translate(form, $component);
                    // sort select options
                    $this.sortSelectOptions(form);
                    // prefill form based on cookie
                    $this.prefillForm(form, $component);
                    // message photo
                    $this.initContactImage($component);
                    // checkbox order
                    $this.initCheckboxOrder($component);
                    // hide fields
                    $this.hideFields($component);
                    // to avoid duplicated id in page, update field id to a random id
                    // currently we just update the checkbox id
                    $this.updateFieldAttributes(form, $component);
                    // init product search field
                    $this.productAutoSuggest($component);
                });
                MktoForms2.whenRendered(function (form) { });
            }
        }, 250);
    };
    // translate field label by field name
    ButtonMarketoFunction.prototype.translate = function (form, $component) {
        var MktoForms2 = window['MktoForms2'];
        var formEl = form.getFormElem()[0];
        var ANCESTORS_STOR = '.mktoFormRow, .mktoFormCol', INPUTS_STOR = 'INPUT, SELECT, TEXTAREA, BUTTON', attrTag = 'data-wrapper-for', _forEach = Array.prototype.forEach;
        // utility fn: tag outer wrapper DIVs with their inner inputs' names to make them seekable
        (function tagMktoWrappers(formEl) {
            _forEach.call(formEl.querySelectorAll(ANCESTORS_STOR), function (ancestor) {
                ancestor.setAttribute(attrTag, '');
                _forEach.call(ancestor.querySelectorAll(INPUTS_STOR), function (input) {
                    var currentTag = ancestor.getAttribute(attrTag);
                    ancestor.setAttribute(attrTag, [currentTag ? currentTag : '', input.name].join(' ').trim());
                });
            });
        })(formEl);
        var translateMapEl = $component.find("[data-map-id=\"translateMap\"]"); // get translations embedded in form rich text area
        var jsonStr = translateMapEl.text();
        if (jsonStr.length > 0) {
            var translateMap = JSON.parse(jsonStr);
            var currentTranslations = translateMap;
            // loop over translatables
            var fieldName, fieldTranslations, propertyName, propertyValue, translateTargetEl;
            for (fieldName in currentTranslations) {
                fieldTranslations = currentTranslations[fieldName];
                for (propertyName in fieldTranslations) {
                    propertyValue = fieldTranslations[propertyName];
                    switch (propertyName) {
                        case 'label':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] LABEL');
                            if (translateTargetEl != null) {
                                translateTargetEl.lastChild.nodeValue = propertyValue;
                            }
                            break;
                        case 'validation':
                            translateTargetEl = MktoForms2.$(formEl.querySelector('[data-wrapper-for="' + fieldName + '"] .mktoFieldDescriptor'));
                            if (translateTargetEl != null) {
                                var mktoFieldDescriptor = translateTargetEl.data('mktoFieldDescriptor');
                                if (mktoFieldDescriptor != undefined) {
                                    mktoFieldDescriptor.validationMessage = propertyValue;
                                }
                            }
                            break;
                        case 'placeholder':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] INPUT');
                            if (translateTargetEl != null) {
                                translateTargetEl.setAttribute('placeholder', propertyValue);
                            }
                            break;
                        case 'submit':
                            translateTargetEl = formEl.querySelector('BUTTON[type="submit"]');
                            if (translateTargetEl != null) {
                                translateTargetEl.innerHTML = propertyValue;
                            }
                            break;
                        case 'html':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"]');
                            if (translateTargetEl != null) {
                                translateTargetEl.innerHTML = propertyValue;
                            }
                            break;
                        case 'options':
                            translateTargetEl = formEl.querySelectorAll('[data-wrapper-for="' + fieldName + '"] OPTION');
                            for (var i = 0; i < translateTargetEl.length; i++) {
                                var val = translateTargetEl[i].value;
                                var txt = propertyValue[val];
                                if (typeof txt !== 'undefined') {
                                    translateTargetEl[i].text = txt;
                                }
                            }
                            break;
                        case 'checkbox':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] .mktoCheckboxList');
                            if (translateTargetEl != null) {
                                var labelEle = translateTargetEl.parentElement.querySelector('label');
                                labelEle.innerHTML = propertyValue;
                            }
                            break;
                        case 'fieldset':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] fieldset legend');
                            if (translateTargetEl != null) {
                                translateTargetEl.innerText = propertyValue;
                            }
                            break;
                        case 'submitprogress':
                            translateTargetEl = formEl.querySelector('BUTTON[type="submit"]');
                            if (translateTargetEl != null) {
                                translateTargetEl.setAttribute('data-submit-progress-text', propertyValue);
                                form.onSubmit(function (form) {
                                    if (form.submittable()) {
                                        translateTargetEl.innerHTML = translateTargetEl.getAttribute('data-submit-progress-text');
                                    }
                                });
                            }
                            break;
                    }
                }
            }
        }
    };
    ButtonMarketoFunction.prototype.sortSelectOptions = function (form) {
        var formEl = form.getFormElem()[0];
        var $form = $(formEl);
        var language = $('html').attr('lang');
        var $selectEles = $form.find('select');
        $selectEles.each(function (i, e) {
            var $options = $(e).find('option');
            var $defaultOption = $options.filter("option[value='']");
            // get the "Other" option in dropdown list
            var $othersOption = $options.filter(function (optIndex, optEle) {
                var optValue = $(optEle)
                    .val()
                    .toString()
                    .toLocaleLowerCase();
                var result = optValue == 'others' || optValue == 'other';
                return result;
            });
            var $optionEles = $options.toArray().sort(function (a, b) {
                var aText = $(a).text();
                var bText = $(b).text();
                var result = aText.localeCompare(bText, language, { ignorePunctuation: true });
                return result;
            });
            $(e).empty();
            $(e).append($optionEles);
            // make the "Select..." option at the top
            if ($defaultOption && $defaultOption.length > 0) {
                $(e).prepend($defaultOption);
            }
            // make the "Others" option at the bottom
            if ($othersOption && $othersOption.length > 0) {
                $(e).append($othersOption);
            }
            var id = $(e).attr('id');
            if (id !== 'formVersion' || (id == 'formVersion' && Track.isKnownMarketoLead() == false)) {
                // make sure the first option is selected
                $(e)
                    .find('option')
                    .first()
                    .prop('selected', true);
            }
        });
    };
    ButtonMarketoFunction.prototype.formatPhoneNumber = function (form) {
        var vals = form.vals();
        var phone = vals.Phone;
        if (typeof phone !== 'undefined') {
            var formattedPhone = phone.replace(/[^0-9]/g, '').replace(/^0*/g, '');
            form.vals({ Phone: formattedPhone });
        }
    };
    ButtonMarketoFunction.prototype.prefillForm = function (form, $component) {
        var _this = this;
        var prefilledFieldsEle = $component.find("div[data-map-id='prefillFields']");
        var prefilledJsonStr = prefilledFieldsEle.text();
        if (prefilledJsonStr.length > 0) {
            var prefillFields = JSON.parse(prefilledJsonStr);
            var formFieldEles = $component.find('div.mktoFormRow');
            var _loop_1 = function () {
                var fieldValue = prefillFields[fieldName];
                formFieldEles.each(function (i, e) {
                    var $fieldEle = $(e);
                    var formFieldId = $fieldEle.data('wrapper-for');
                    if (fieldName.toLocaleLowerCase() == formFieldId.toLocaleLowerCase()) {
                        if (fieldValue != null) {
                            var type = $fieldEle.find('input').attr('type');
                            if (type == 'checkbox') {
                                if (fieldValue == 'true') {
                                    fieldValue = 'yes';
                                }
                            }
                            var obj = _this.GenerateObject(formFieldId, fieldValue);
                            form.vals(obj);
                        }
                    }
                });
            };
            for (var fieldName in prefillFields) {
                _loop_1();
            }
        }
    };
    ButtonMarketoFunction.prototype.GenerateObject = function (formFieldId, formFieldValue) {
        var jsonStr = "{\"" + formFieldId + "\":\"" + formFieldValue + "\"}";
        var obj = JSON.parse(jsonStr);
        return obj;
    };
    ButtonMarketoFunction.prototype.initCheckboxOrder = function ($component) {
        var $formCheckbox = $component.find('[type="checkbox"]');
        if ($formCheckbox.length > 0) {
            $formCheckbox.parents('.mktoFormRow').css('order', '1');
        }
    };
    ButtonMarketoFunction.prototype.initContactImage = function ($component) {
        var $contactImage = $component.find("." + this.classes.contactImage);
        var $formMessage = $component.find("textarea[name='formMessage']");
        if ($contactImage.length > 0 && $formMessage.length > 0) {
            $component.addClass(this.classes.stateHasImage);
        }
    };
    ButtonMarketoFunction.prototype.initMessageBox = function ($component) {
        var _this_1 = this;
        $component.find("textarea[name='formMessage']").on('focus', function (ev) {
            $component.addClass(_this_1.classes.stateAdditionalFieldsVisible);
        });
    };
    ButtonMarketoFunction.prototype.updateFieldAttributes = function (form, $component) {
        var $formEl = $(form.getFormElem()[0]);
        var rando = new Date().getTime() + parseInt((Math.random() * 1000).toString());
        var $checkboxes = $formEl.find('.mktoField');
        $checkboxes.each(function (i, e) {
            var $chk = $(e);
            var chkId = $chk.attr('id');
            var newChkId = chkId + "_" + rando;
            if (chkId != undefined) {
                if (!chkId.includes('_')) {
                    // update checkbox id
                    $chk.attr('id', newChkId);
                    // update label-for attribute
                    $chk.parents('.mktoFieldWrap')
                        .find("label[for=" + chkId + "]")
                        .attr('for', newChkId);
                }
            }
        });
        var formId = $formEl.attr('id');
        var newFormId = formId + "_" + rando;
        if (formId != undefined) {
            if (!formId.includes('_', 9)) {
                $formEl.attr('id', newFormId);
            }
        }
    };
    ButtonMarketoFunction.prototype.hideFields = function ($component) {
        var hiddenFieldsStr = $component.find("div[data-map-id='hiddenFields']").text();
        var hiddenFieldsArr = hiddenFieldsStr.split(',');
        var campaignId = $component.data('mktoflow-campaignid');
        var formcampaignId = $component.data('mktoflow-formcampaignid');
        var siteCampaignId = $component.data('mktoflow-sitecampaignid');
        //let pageCampaignId = $("header").data("page-mktocampaign-id");
        var $formContainer = $component.find("div[data-id='formContainer']");
        if (campaignId === undefined) {
            campaignId = $formContainer.data('mktoflow-campaignid');
        }
        if (formcampaignId === undefined) {
            formcampaignId = $formContainer.data('mktoflow-formcampaignid');
        }
        if (siteCampaignId === undefined) {
            siteCampaignId = $formContainer.data('mktoflow-sitecampaignid');
        }
        var formFieldEles = $component.find('div.mktoFormRow');
        var _loop_2 = function () {
            var fieldName = hiddenFieldsArr[field];
            formFieldEles.each(function (i, e) {
                var $fieldEle = $(e);
                var formFieldId = $fieldEle.data('wrapper-for');
                if (fieldName.toLocaleLowerCase() == formFieldId.toLocaleLowerCase()) {
                    $fieldEle.addClass('mktoFormRowHide');
                }
            });
        };
        for (var field in hiddenFieldsArr) {
            _loop_2();
        }
        formFieldEles.each(function (i, e) {
            var $fieldEle = $(e);
            var formFieldId = $fieldEle.data('wrapper-for');
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden') {
                $fieldEle.addClass('mktoFormRowHide');
            }
            if (formFieldId == '') {
                $fieldEle.addClass('mktoFormRowHide');
            }
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceIndustry') {
                $fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPageIndustrytags').val());
            }
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceMaterial') {
                $fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPageMaterialtags').val());
            }
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceTheme') {
                $fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPagePreferenceTheme').val());
            }
            var urlParams = new URLSearchParams(window.location.search);
            var utmId = '';
            if (urlParams.has('utm_id')) {
                utmId = urlParams.get('utm_id');
            }
            if (typeof campaignId === 'undefined') {
                if (typeof utmId === 'string' && utmId.length === 0) {
                    if (typeof formcampaignId === 'undefined') {
                        if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                            $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID') {
                            $fieldEle.find('input[name="' + formFieldId + '"]').val(siteCampaignId);
                        }
                    }
                    else {
                        if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                            $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID') {
                            $fieldEle.find('input[name="' + formFieldId + '"]').val(formcampaignId);
                        }
                    }
                }
                else {
                    if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                        $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID') {
                        $fieldEle.find('input[name="' + formFieldId + '"]').val(utmId);
                    }
                }
            }
            else {
                if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                    $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'mktoCampaignID') {
                    $fieldEle.find('input[name="' + formFieldId + '"]').val(campaignId);
                }
            }
        });
    };
    ButtonMarketoFunction.prototype.productAutoSuggest = function ($component) {
        var _this = this;
        var autosuggestObjJsonStr = $component.find("div[data-map-id='autosuggestObj']").text();
        if (autosuggestObjJsonStr.length > 0) {
            var autoObj_1 = JSON.parse(autosuggestObjJsonStr);
            if (autoObj_1.FieldName && autoObj_1.FieldName.length > 0) {
                var $autoEle_1 = $component.find("." + this.classes.autoSuggestDropdown);
                // disable browser's autocomplete feature
                $component.find("input[name='" + autoObj_1.FieldName + "']").on('focus', function (ev) {
                    $(ev.currentTarget).attr('autocomplete', 'off');
                });
                $component.find("input[name='" + autoObj_1.FieldName + "']").on('input propertychange', function (ev) {
                    var $target = $(ev.currentTarget);
                    $target.attr('data-t-uvpno', '');
                    $target.addClass('js-m-mkto-form-productname', '');
                    var val = $target.val();
                    if (val.length >= 2) {
                        $.ajax({
                            type: 'GET',
                            url: autoObj_1.Endpoint,
                            dataType: 'json',
                            data: {
                                term: val,
                                permissionQuery: autoObj_1.PermissionQuery,
                                max: autoObj_1.MaxItem,
                                lang: autoObj_1.Language,
                            },
                            success: function (response) {
                                if (response) {
                                    // clear dropdown
                                    $autoEle_1.empty();
                                    // render brand dropdown items
                                    //_this.renderDropdown($autoEle, response.suggestions, autoObj.BrandLabel);
                                    // render product dropdown items
                                    _this.renderDropdown($autoEle_1, response.productSuggestions, autoObj_1.ProductLabel);
                                    // rebind dropdown items event
                                    if ($autoEle_1.children().length > 0) {
                                        _this.rebindDropdownEvents($component, autoObj_1.FieldName);
                                    }
                                    // render no result found label
                                    else {
                                        var labelContent = _this.generateDropdownLabelContent(val, autoObj_1.NoResultLabel);
                                        $autoEle_1.append(labelContent);
                                    }
                                    _this.showDropdown($autoEle_1, $target);
                                }
                            },
                            complete: function () { },
                            error: function (xhr, status, error) {
                                console.log("marketo form, get product auto-suggest data error, " + xhr.status + ", " + xhr.statusText + ", " + error);
                            },
                        });
                    }
                    else {
                        $autoEle_1.removeAttr('style');
                    }
                });
                _this.resizeDropdown($component, autoObj_1.FieldName);
                _this.autoHideDropdown($component, autoObj_1.FieldName);
            }
        }
    };
    ButtonMarketoFunction.prototype.generateDropdownItemContent = function (text, uvptext) {
        var htmlContent = "<li class=\"m-marketo-form__filter-dropdown-item " + this.classes.dropdownItem + "\" data-t-uvp=" + uvptext + ">" + text + "</li>";
        return htmlContent;
    };
    ButtonMarketoFunction.prototype.generateDropdownLabelContent = function (text, NoResultLabel) {
        if (NoResultLabel === void 0) { NoResultLabel = ''; }
        if (text == 'Product') {
            var htmlContent = "<li class=\"m-marketo-form__filter-dropdown-item m-marketo-form__filter-dropdown-item--label js-m-marketo-form_dropdown-label\">" + text + "</li>";
            return htmlContent;
        }
        else {
            var htmlContent = "<li class=\"m-marketo-form__filter-dropdown-item m-marketo-form__filter-dropdown-item--label js-m-marketo-form_dropdown-label m-marketo-form__noresult\"> " + NoResultLabel + " <b>" + text + "</b></li>";
            return htmlContent;
        }
    };
    ButtonMarketoFunction.prototype.hiddenFormSubmit = function ($formNode) {
        var typeOfForm = $formNode.data('show-message');
        var trackdata = {
            event: 'hidden_form_submit',
            form_id: $($formNode).attr('id'),
            form_name: typeOfForm,
            form_destination: '',
            form_hidden_submit_text: '',
        };
        Track.gtmTrack(trackdata);
    };
    ;
    ButtonMarketoFunction.prototype.resizeDropdown = function ($component, fieldName) {
        var _this_1 = this;
        $(window).on('resize', function () {
            var $target = $component.find("input[name='" + fieldName + "']");
            if ($target.length > 0) {
                var currentTop = $target.closest('.mktoFormRow').position().top + $target.outerHeight();
                var currentLeft = $target.closest('.mktoFormRow').position().left;
                var currentWidth = $target.outerWidth();
                $component.find("." + _this_1.classes.autoSuggestDropdown).css({
                    top: currentTop + "px",
                    left: currentLeft + "px",
                    width: currentWidth + "px",
                });
            }
        });
    };
    ButtonMarketoFunction.prototype.renderDropdown = function ($autoEle, data, label) {
        var _this_1 = this;
        if (data && data.length > 0) {
            var labelContent = this.generateDropdownLabelContent(label);
            $autoEle.append(labelContent);
            data.forEach(function (d) {
                var htmlContent = _this_1.generateDropdownItemContent(d.value, d.uvp);
                $autoEle.append(htmlContent);
            });
        }
    };
    ButtonMarketoFunction.prototype.rebindDropdownEvents = function ($component, fieldName) {
        var _this = this;
        $component.find("." + this.classes.dropdownItem).on('click', function (e) {
            var $target = $(e.target);
            var value = $target.text();
            var uvpno = $target.attr('data-t-uvp');
            $component.find("input[name='" + fieldName + "']").val(value);
            $component.find("input[name='" + fieldName + "']").attr('data-t-uvpno', uvpno);
            _this.setProductInfo($component, value);
        });
    };
    ButtonMarketoFunction.prototype.setProductInfo = function ($component, value) {
        var autosuggestObjJsonStr = $component.find("div[data-map-id='autosuggestObj']").text();
        if (autosuggestObjJsonStr.length > 0) {
            var autoObj = JSON.parse(autosuggestObjJsonStr);
            $.ajax({
                type: 'GET',
                url: autoObj.Endpoint,
                dataType: 'json',
                data: {
                    term: value,
                    permissionQuery: autoObj.PermissionQuery,
                    max: autoObj.MaxItem,
                    lang: autoObj.Language,
                    extended: 'true',
                },
                success: function (response) {
                    if (response) {
                        if (response.productSuggestions && response.productSuggestions.length > 0) {
                            var uvpFieldName = 'productUVP';
                            //set hidden productUVP value
                            if ($component.attr('data-UvPFieldName').length > 0) {
                                uvpFieldName = $component.attr('data-UvPFieldName');
                            }
                            if ($component.find("input[name='" + uvpFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].uvp) {
                                    $component
                                        .find("input[name='" + uvpFieldName + "']")
                                        .val(response.productSuggestions[0].uvp);
                                }
                                else {
                                    $component.find("input[name='" + uvpFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredProductBrandInterest value
                            var brandFieldName = 'inferredProductBrandInterest';
                            if ($component.attr('data-BrandFieldName').length > 0) {
                                brandFieldName = $component.attr('data-BrandFieldName');
                            }
                            if ($component.find("input[name='" + brandFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].brand) {
                                    $component
                                        .find("input[name='" + brandFieldName + "']")
                                        .val(response.productSuggestions[0].brand);
                                }
                                else {
                                    $component.find("input[name='" + brandFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredMaterialInterest value
                            var materialFieldName = 'inferredMaterialInterest';
                            if ($component.attr('data-MaterialFieldName').length > 0) {
                                materialFieldName = $component.attr('data-MaterialFieldName');
                            }
                            if ($component.find("input[name='" + materialFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].materials &&
                                    response.productSuggestions[0].materials.length > 0) {
                                    var value = '';
                                    if (response.productSuggestions[0].materials.length == 1) {
                                        value = response.productSuggestions[0].materials[0];
                                    }
                                    else {
                                        response.productSuggestions[0].materials.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[name='" + materialFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[name='" + materialFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredApplicationInterest value
                            var applicationFieldName = 'inferredApplicationInterest';
                            if ($component.attr('data-ApplicationFieldName').length > 0) {
                                applicationFieldName = $component.attr('data-ApplicationFieldName');
                            }
                            if ($component.find("input[name='" + applicationFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].applications &&
                                    response.productSuggestions[0].applications.length > 0) {
                                    var value = '';
                                    if (response.productSuggestions[0].applications.length == 1) {
                                        value = response.productSuggestions[0].applications[0];
                                    }
                                    else {
                                        response.productSuggestions[0].applications.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[name='" + applicationFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[name='" + applicationFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredIndustryInterest value
                            var industryFieldName = 'inferredIndustryInterest';
                            if ($component.attr('data-IndustryFieldName').length > 0) {
                                industryFieldName = $component.attr('data-IndustryFieldName');
                            }
                            if ($component.find("input[name='" + industryFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].industries &&
                                    response.productSuggestions[0].industries.length > 0) {
                                    var value = '';
                                    if (response.productSuggestions[0].industries.length == 1) {
                                        value = response.productSuggestions[0].industries[0];
                                    }
                                    else {
                                        response.productSuggestions[0].industries.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[name='" + industryFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[name='" + industryFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredBUInterest value
                            var businessUnitFieldName = 'inferredBUInterest';
                            if ($component.attr('data-BusinessUnitFieldName').length > 0) {
                                businessUnitFieldName = $component.attr('data-BusinessUnitFieldName');
                            }
                            if ($component.find("input[name='" + businessUnitFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].businessUnits &&
                                    response.productSuggestions[0].businessUnits.length > 0) {
                                    var value = '';
                                    if ((response.productSuggestions[0].businessUnits.length = 1)) {
                                        value = response.productSuggestions[0].businessUnits[0];
                                    }
                                    else {
                                        response.productSuggestions[0].businessUnits.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[name='" + businessUnitFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[name='" + businessUnitFieldName + "']").val('');
                                }
                            }
                        }
                    }
                },
                complete: function () { },
                error: function (xhr, status, error) {
                    console.log("marketo form, get product auto-suggest data error, " + xhr.status + ", " + xhr.statusText + ", " + error);
                },
            });
        }
    };
    ButtonMarketoFunction.prototype.showDropdown = function ($autoEle, $fieldEle) {
        var currentTop = $fieldEle.closest('.mktoFormRow').position().top + $fieldEle.outerHeight();
        var currentLeft = $fieldEle.closest('.mktoFormRow').position().left;
        var currentWidth = $fieldEle.outerWidth();
        $autoEle.css({
            top: currentTop + "px",
            left: currentLeft + "px",
            width: currentWidth + "px",
        });
        $autoEle.show();
    };
    ButtonMarketoFunction.prototype.autoHideDropdown = function ($component, fieldName) {
        var _this_1 = this;
        $component.find("input[name='" + fieldName + "']").on('click', function (ev) {
            ev.stopPropagation();
        });
        $('body').on('click', function () {
            $component.find("." + _this_1.classes.autoSuggestDropdown).removeAttr('style');
            var uvpno = $component.find('.js-m-mkto-form-productname').attr('data-t-uvpno');
            if (uvpno === undefined || uvpno === '') {
                $component.find('.js-m-mkto-form-productname').val('');
            }
        });
    };
    ButtonMarketoFunction.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ButtonMarketoFunction.ctorParameters = function () { return []; };
    ButtonMarketoFunction.propDecorators = {
        button: [{ type: Input }],
        disabled: [{ type: Input }],
        emitEvent: [{ type: Input }],
        buttonClick: [{ type: Output }]
    };
    ButtonMarketoFunction.ngInjectableDef = i0.defineInjectable({ factory: function ButtonMarketoFunction_Factory() { return new ButtonMarketoFunction(); }, token: ButtonMarketoFunction, providedIn: "root" });
    return ButtonMarketoFunction;
}());
export { ButtonMarketoFunction };
//# sourceMappingURL=button.component.marketo.js.map